import React from "react";

const ContactSkeleton: React.FC = () => {
  return (
    <>
      <div className="section relative flex justify-center pb-0 max-sm:p-4 blue-bg-dots">
        <div className="container mx-auto px-4 max-sm:px-0 grid grid-cols-3 gap-8 my-10">
          <div className="col-span-2 max-lg:col-span-3">
            <h3 className="text-[#91DBE7] text-6xl max-md:text-4xl text-start">
              <div className="h-8 w-56 bg-gray-300 skeleton rounded"></div>
            </h3>

            <div className="my-8 grid grid-cols-2 gap-6 f-family-mochiy-pop relative z-0">
              <div className="w-full max-sm:col-span-2">
                <label className="block text-[#D854BB] text-base mb-1">
                  <div className="h-6 w-36 bg-gray-300 skeleton rounded mb-2"></div>
                </label>
                <div className="relative">
                  <div className="h-12 w-full bg-gray-300 skeleton rounded"></div>
                </div>
              </div>

              <div className="w-full max-sm:col-span-2">
                <label className="block text-[#D854BB] text-base mb-1">
                  <div className="h-6 w-36 bg-gray-300 skeleton rounded mb-2"></div>
                </label>
                <div className="relative">
                  <div className="h-12 w-full bg-gray-300 skeleton rounded"></div>
                </div>
              </div>

              <div className="w-full max-sm:col-span-2">
                <label className="block text-[#D854BB] text-base mb-1">
                  <div className="h-6 w-36 bg-gray-300 skeleton rounded mb-2"></div>
                </label>
                <div className="relative">
                  <div className="h-12 w-full bg-gray-300 skeleton rounded"></div>
                </div>
              </div>

              <div className="w-full max-sm:col-span-2">
                <label className="block text-[#D854BB] text-base mb-1">
                  <div className="h-6 w-36 bg-gray-300 skeleton rounded mb-2"></div>
                </label>
                <div className="relative">
                  <div className="h-12 w-full bg-gray-300 skeleton rounded"></div>
                </div>
              </div>

              <div className="w-full max-sm:col-span-2 relative">
                <label className="block text-[#D854BB] text-base mb-1">
                  <div className="h-6 w-36 bg-gray-300 skeleton rounded mb-2"></div>
                </label>
                <div className="relative">
                  <div className="h-12 w-full bg-gray-300 skeleton rounded"></div>
                </div>
              </div>

              <div className="w-full col-span-2">
                <label className="block text-[#D854BB] text-base mb-1">
                  <div className="h-6 w-36 bg-gray-300 skeleton rounded mb-2"></div>
                </label>
                <div className="h-36 w-full bg-gray-300 skeleton rounded p-[1.6rem]"></div>
              </div>

              <div className="max-md:text-center">
                <div className="h-14 w-2/4 bg-gray-300 skeleton rounded"></div>
              </div>
            </div>
          </div>

          <div className="max-lg:hidden mt-36 ml-24 rotate-[-360]">
            <div className="h-[500px] w-[350px] bg-gray-300 skeleton rounded"></div>
          </div>
        </div>
      </div>
    </>
  );
};
export default ContactSkeleton;
